import { ValidatorsService } from './Core/Abstract/validators/validators.service';
//Core-Angular
import { NgModule, APP_INITIALIZER, LOCALE_ID  } from '@angular/core';
import { DecimalPipe, DatePipe, CurrencyPipe  } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule ,HttpClient , HTTP_INTERCEPTORS} from '@angular/common/http';
import { TokenInterceptor } from './Core/Auth/token.interceptor';
import { FormsModule,ReactiveFormsModule,Validators }   from '@angular/forms';
import { registerLocaleData } from '@angular/common';
//CoreUI 
import { AppComponent } from './app.component';
import { NAV_DROPDOWN_DIRECTIVES } from './Core/Abstract/nav-dropdown.directive';
import { FormlyFieldSelect } from './Core/Abstract/CustomFormlyTemplate/formly-field-select';
import { FormlyFieldFile } from './Core/Abstract/CustomFormlyTemplate/formly-field-file';
import { FormlyFieldButton } from './Core/Abstract/CustomFormlyTemplate/formly-field-button';
import { FormlyFieldCountryCode } from './Core/Abstract/CustomFormlyTemplate/formly-field-country-code';
import { FormlyFieldInput } from './Core/Abstract/CustomFormlyTemplate/formly-field-input';
import { PanelWrapperComponent } from './Core/Abstract/CustomFormlyTemplate/panel-wrapper.component';

import { FormlyFieldRadio } from './Core/Abstract/CustomFormlyTemplate/formly-field-radio';
import { FormlyFieldTextarea } from './Core/Abstract/CustomFormlyTemplate/formly-field-textarea';

//Routing Module
import { AppRoutingModule } from './app.routing';

import { AuthService } from './Core/Auth/auth.service';

//Layouts
import { TableLayoutComponent } from './Core/Abstract/Grid/table-layout.component';
import { FormatCellPipe } from './Core/Abstract/Grid/format-cell.pipe';
import { StyleCellDirective } from './Core/Abstract/Grid/style-cell.directive';
import { TranslateService } from '@ngx-translate/core';

//ngx-bootstrap
import { AlertModule } from 'ngx-bootstrap/alert';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SortableModule } from 'ngx-bootstrap/sortable';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';

//datepicker
import { Ng2DatetimePickerModule }    from './datepicker'; 
import { registerValidators } from './validator.extension';

//Custom Select/Dropdown
// import { SelectModule } from './select';

//Logout Timer

//Generic Upload Files

//Custom scroll 
import { PerfectScrollbarModule } from 'ngx-om-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-om-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-om-perfect-scrollbar';

//Currency input

//Localization (for Pipes)
import localEL from '@angular/common/locales/el';
registerLocaleData(localEL);

//CAPTCHA

//Notification / Alert module



const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

/**
 * Tesla
 */

//Core
import { ConfigService } from './Core/Abstract/config.service';
import { EventsEmitterService } from './Core/Abstract/emitter.service';
import { LogService } from './Core/Abstract/log.service';
import { RoutingComponent } from './Core/Routes/routing.component';
import { SecurityService } from './Core/Security/security.service';
import { VisualsService } from './Core/Abstract/visuals.service';
import { WebXmlComponent } from './Core/Routes/webxml.component';
import { BaseCRUDComponent } from './Core/Abstract/baseCRUD.component';

// new theme
import { SpinnerComponent } from '@core/Abstract/shared/spinner.component';
import { FullComponent } from '@core/Abstract/layouts/full/full.component';
import { BlankComponent } from '@core/Abstract/layouts/blank/blank.component';
import { NavigationComponent } from '@core/Abstract/shared/header-navigation/navigation.component';
import { ChangeLanguageComponent } from '@core/Abstract/shared/changeLanguage/changeLanguage.component';
import { BreadcrumbComponent } from '@core/Abstract/shared/breadcrumb/breadcrumb.component';
import { SidebarComponent } from '@core/Abstract/shared/sidebar/sidebar.component';
import { RoutesService } from '@core/Routes/routes.service';
import { TimerComponent } from '@core/Abstract/shared/timer/timer.component';
import { OtpTimerComponent } from '@core/Abstract/shared/timer/otp-timer.component';

import { LoaderComponent } from '@core/Abstract/shared/loader/loader.component';
import { NotificationsComponent } from '@core/Abstract/shared/notifications/notifications.component';
import { FooterComponent } from '@core/Abstract/shared/footer/footer.component';


//login
import { RegisterComponent } from './Core/Register/register.component';
import { ForgotPasswordComponent } from './Core/Login/forgotPassword.component';
import { LogInComponent } from './Core/Login/login.component';
import { ChangePasswordComponent } from './Core/Login/changePassword.component';
import { ConfirmComponent } from './Core/Register/confirm.component';
import { RejectComponent } from './Core/Register/reject.component';
import { ResetPasswordComponent } from './Core/Login/resetPassword.component';


//Dynamic Forms
import { DynamicFormComponent } from './dynamic-form/containers/dynamic-form/dynamic-form.component';

//Grids 
import { HomeComponent } from './Menus/Home/home.component';

//upload
import { FileUploaderComponent } from "./Menus/FileUploader/fileUploader.component";
import {ToastrModule} from 'ngx-toastr';
//Modals
//search
import { ClaccModalComponent } from './Modals/Clacc/claccModal.component';
import { DocumentsComponent } from './Menus/Documents/documents.component';
import { FileUploadModule } from 'ng2-file-upload';
import { FormlyModule, FieldType , FORMLY_CONFIG } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

//Onboarding
import { OnboardEditComponent } from './Menus/Onboard/onboard.component';
import { OnBoardedComponent } from './Menus/Onboard/Onboarded/onboarded.component';
import { InviteComponent } from './Menus/Invite/invite.component';
import { UserListComponent } from './Menus/UserList/userList.component';
import { WelcomeScreenComponent } from './Menus/WelcomeScreen/welcomeScreen.component';
import { ValidateCustomerComponent } from './Menus/ValidateCustomer/validateCustomer.component';
import { ContactUsComponent } from './Menus/Onboard/ContactUs/contactUs.component'
import { CloneDataComponent } from './Menus/Onboard/CloneData/cloneData.component'
import { InlineFileUploaderComponent } from './Menus/Onboard/OnboardFiles/inlinefileuploader.component';
import { OnboardFilesComponent } from './Menus/Onboard/OnboardFiles/onboardfiles.component';
import { RepeatTypeComponent } from './Core/Abstract/FormArray/repeat-section.type';
import { FormControl, ValidationErrors } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldDate } from './Core/Abstract/CustomFormlyTemplate/formly-field-date';
import { showError } from '@core/Abstract/validators/validators';

//Pipes
import { FilterListPipe } from './pipes';
import { SafeHtmlPipe } from './htmlPipe';
import { ArraySortPipe } from './sortPipe';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { NgIdleModule } from '@ng-idle/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, RecaptchaLoaderOptions, RECAPTCHA_LOADER_OPTIONS } from "ng-recaptcha";
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask';
import { FormlyFieldCheckbox } from '@core/Abstract/CustomFormlyTemplate/formly-field-checkbox';

export function getConfig(config:ConfigService) {
  return () => config.load();
}

export function getLocale(config:ConfigService) {
  return config.getLocale();
}

export function recaptchaSettingsFactory(config: ConfigService): string {
  return config.getReCaptchaSiteKey();
}

export function recaptchaLoaderFactory(config: ConfigService): RecaptchaLoaderOptions {
  return { 
    onBeforeLoad(_url) {
      const recaptchaUrl = new URL(config.getReCaptchaUrl());
      // optionally, set the locale:
      recaptchaUrl.searchParams.set("hl", config.getCurrentLocaleStr());
      
      return {
        url: recaptchaUrl
      };
    }
  }
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "/assets/i18n/", ".json");
}
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  decimal: ",",
  precision: 2,
  prefix: "",
  suffix: "",
  thousands: ".",
};
@NgModule({
    imports: [
      CurrencyMaskModule,
        NgbModule,
        BrowserModule, BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        Ng2DatetimePickerModule,
        ReactiveFormsModule,
        PerfectScrollbarModule,
        ModalModule.forRoot(),
        CollapseModule.forRoot(),
        TooltipModule.forRoot(),
        TabsModule.forRoot(),
        PopoverModule.forRoot(),
        SortableModule.forRoot(),
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        BsDropdownModule.forRoot(),
        NgIdleModule.forRoot(),
        NgSelectModule,
        RecaptchaV3Module,
        ToastrModule.forRoot({
          timeOut: 7000,
          positionClass: 'toast-top-right',
          newestOnTop: false,
          progressBar: true,
          progressAnimation: 'increasing',
        }),
        FileUploadModule,
        FormlyBootstrapModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        FormlyModule.forRoot({
            types: [
                { name: 'repeat', component: RepeatTypeComponent },
                { name: 'select', component: FormlyFieldSelect },
                { name: 'file', component: FormlyFieldFile },
                { name: 'button', component: FormlyFieldButton },
                { name: 'input', component: FormlyFieldInput },
                { name: 'radio', component: FormlyFieldRadio },
                { name: 'textarea', component: FormlyFieldTextarea },
                { name: 'countryCode', component: FormlyFieldCountryCode },
                { name: 'panel', component: PanelWrapperComponent },
                { name: 'date', component: FormlyFieldDate },
                { name: 'checkbox', component: FormlyFieldCheckbox }
            ],
            extras: { showError, checkExpressionOn: 'modelChange', immutable: true }
        })
    ],
    providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy },
        ConfigService,
        EventsEmitterService,
        SecurityService,
        AuthService,
        LogService,
        VisualsService,
        WebXmlComponent,
        DatePipe,
        DecimalPipe,
        CurrencyPipe,
        ValidatorsService,
        { provide: FORMLY_CONFIG, multi: true, useFactory: registerValidators, deps: [TranslateService, ValidatorsService] },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useFactory: recaptchaSettingsFactory,
            deps: [ConfigService]
        },
        {
          provide: RECAPTCHA_LOADER_OPTIONS,
          useFactory: recaptchaLoaderFactory,
          deps: [ConfigService]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: getConfig,
            deps: [ConfigService],
            multi: true
        },
        {
            provide: LOCALE_ID,
            useFactory: getLocale,
            deps: [ConfigService],
        },
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        {
          provide: CURRENCY_MASK_CONFIG,
          useValue: CustomCurrencyMaskConfig,
        },
        RoutesService
    ],
    declarations: [
        //Core
        FormlyFieldSelect,
        FormlyFieldInput,
        FormlyFieldRadio,
        FormlyFieldTextarea,
        RepeatTypeComponent,
        FormlyFieldFile,
        FormlyFieldButton,
        FormlyFieldCountryCode,
        FormlyFieldDate,
        PanelWrapperComponent,
        AppComponent,
        SpinnerComponent,
        FullComponent,
        BlankComponent,
        NavigationComponent,
        ChangeLanguageComponent,
        FooterComponent,
        BreadcrumbComponent,
        SidebarComponent,
        TimerComponent,
        OtpTimerComponent,
        NotificationsComponent,
        LoaderComponent,
        NAV_DROPDOWN_DIRECTIVES,
        TableLayoutComponent,
        FormatCellPipe,
        StyleCellDirective,
        DynamicFormComponent,
        RoutingComponent,
        BaseCRUDComponent,
        //login
        RegisterComponent,
        ForgotPasswordComponent,
        ConfirmComponent,
        LogInComponent,
        ChangePasswordComponent,
        RejectComponent,
        ResetPasswordComponent,
        //Modals
        //search
        ClaccModalComponent,
        //Grids
        HomeComponent,
        DocumentsComponent,
        OnboardEditComponent,
        UserListComponent,
        WelcomeScreenComponent,
        ValidateCustomerComponent,
        OnBoardedComponent,
        ContactUsComponent,
        CloneDataComponent,
        OnboardFilesComponent,
        InviteComponent,
        //uploads
        FileUploaderComponent,
        InlineFileUploaderComponent,
        //Pipe
        FilterListPipe,
        SafeHtmlPipe,
        ArraySortPipe
    ],
    bootstrap: [AppComponent]
})


export class AppModule { }
